import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { DefaultNavigationContext } from "@typings/Page";
import { HttpStatusCode } from "axios";

import NewsletterSignupPageContent from "./NewsletterSignupPageContent";

export default function NewsletterSignupPage(): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<DefaultNavigationContext, string>>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {(context: DefaultNavigationContext) => {
        const { kind, data } = context;

        // Load article page content.
        if (kind === "none") {
          return (
            <NewsletterSignupPageContent seoFooterData={data.seoFooterData} />
          );
        }

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
